let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jkuie")).then(() => parcelRequire('iKnZb'));